import { defineComponent as _defineComponent } from 'vue'
import IUpdatePasswordForm from '@/ui/views/updatepassword/updatepassword.interface';
import { ref } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'ChangeOneTimePasswordForm',
  props: {
    currentPasswordText: null,
    newPasswordText: null,
    confirmPasswordText: null,
    submitButtonText: null,
    showSpinner: { type: Boolean },
    errorMessage: null
  },
  emits: ["form-submitted"],
  setup(__props: any, { emit }: { emit: ({(e: 'form-submitted', value: IUpdatePasswordForm): void}), expose: any, slots: any, attrs: any }) {





const formData = ref<IUpdatePasswordForm>({
    currentPassword: null,
    newPassword: null,
    confirmPassword: null
});

async function handleSubmit() {
    emit('form-submitted', formData.value);
}

return { __sfc: true,emit, formData, handleSubmit }
}

})